import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ContextMenuButton from 'Common/Components/ContextMenuButton';
import Button from 'shared/ui/Button';
import EditColumnContext from 'Common/Components/EditColumnContext';
import { selectFields } from 'store/Preferences/workspace/selectors';
import { resetDefault, setFieldVisibility, setNewOrderColumns } from 'store/Preferences/workspace/actions';
import { EditColumns } from 'Screens/Contextualization/Manage/components/CustomActionBar/styled';

// eslint-disable-next-line import/prefer-default-export
export const AddRemoveColumnsButton = () => {
  const [showContext, toggleContext] = useState(false);
  const dispatch = useDispatch();
  const fields = useSelector(selectFields);

  const addRemoveColumns = (
    <EditColumnContext
      trigger="action-button-column"
      fields={ fields }
      toggle={ () => toggleContext(!showContext) }
      setFieldVisibility={ (fieldObj, value) => dispatch(setFieldVisibility(fieldObj, value)) }
      setNewOrderColumns={ (columns) => dispatch(setNewOrderColumns(columns)) }
      resetDefault={ () => dispatch(resetDefault()) }
      entity="workspaces"
    />
  );

  return (
    <ContextMenuButton
      opened={ showContext }
      menu={ addRemoveColumns }
      trigger="action-button-column"
      display
      icon={ <Button variant="ghost" startIcon={ <EditColumns /> } title="More" ariaLabel="More" onClick={ () => {} } /> }
    />
  );
};
